import React from "react";
import UpdateFrontendButton from "../components/UpdateFrontendButton";
import { useFrontendVersionChecker } from "../hooks/useFrontendVersionChecker";

const FrontendVersionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const showUpdate = useFrontendVersionChecker();
  return (
    <>
      {children}
      {showUpdate && (
        <UpdateFrontendButton onReload={() => window.location.reload()} />
      )}
    </>
  );
};

export default FrontendVersionProvider;
